/** The keys for the service addons in the app */
// export const serviceAddons = [ 'shop', 'order-tracking', 'repair-services', 'atms', 'cyber-dashboard', 'managed-services' ] as const

import { ServiceAddonNames } from 'src/app/core/models/service-addon-roles';

/** Models the service addon type */
// export type ServiceAddonNames = typeof serviceAddons[number]

export const allowedGlobalSearchServiceAddon: ServiceAddonNames[] = [
  'order-tracking',
  'repair-services',
  'managed-services',
];

export const everGreenTiles = ['roles-permissions', 'help-center'] as const;

export type EverGreenTile = (typeof everGreenTiles)[number];
